module.exports = __webpack_public_path__ + "weathericons-regular-webfont.1cd48d78f06d33973d9d.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/css/weather/font/weathericons-regular-webfont.woff2
// module id = ../../../../../theme/css/weather/font/weathericons-regular-webfont.woff2
// module chunks = styles